<div class="flex flex-col justify-center items-center pt-[100px] z-10">
    <div class="font-outfit text-3xl font-semibold mb-6">
        our process
    </div>
    <div class="px-4 sm:px-[20%] text-center text-sm sm:text-base relative z-10">
        SEM Nexus retains an incredible group of social media influencers with large, dedicated followings. Learn how
        SEM Nexus delivers outstanding influencer marketing with our established database, specialized bespoke searches,
        and full end-to-end campaign management.
    </div>
    <div class="mt-[64px] px-1 sm:px-[10%] w-full flex custom-col-display">
        <div class="flex items-center justify-center flex-col w-[351px] mb-8">
            <div class="flex items-center justify-center w-full">
                <img class="h-[130px]" src="/images/shared/steps/01.png" alt="">
            </div>
            <div class="flex flex-col mt-8 items-center justify-center w-full">
                <div class="font-outfit text-2xl font-semibold mb-2 text-center w-full">
                    established<br>database
                </div>
                <div class="font-inter text-sm sm:text-base text-center">
                    We have thousands of influencers for any brand and budget. If not, we'll find the right one just for
                    you.
                </div>
            </div>
        </div>
        <div class="flex items-center justify-center flex-col w-[351px] mb-8">
            <div class="flex items-center justify-center w-full">
                <img class="w-[191px]" src="/images/shared/steps/02.png" alt="">
            </div>
            <div class="flex flex-col mt-8 items-center justify-center w-full">
                <div class="font-outfit text-2xl font-semibold mb-2 text-center w-full">
                    bespoke<br>searches
                </div>
                <div class="font-inter text-sm sm:text-base text-center">
                    We'll search across all platforms with a strategy tailored to your needs, delivering top creators
                    until we find the perfect fit.
                </div>
            </div>
        </div>
        <div class="flex items-center justify-center flex-col w-[351px] mb-8">
            <div class="flex items-center justify-center w-full">
                <img class="w-[191px]" src="/images/shared/steps/03.png" alt="">
            </div>
            <div class="flex flex-col mt-8 items-center justify-center w-full">
                <div class="font-outfit text-2xl font-semibold mb-2 text-center w-full">
                    end-to-end campaign<br>management
                </div>
                <div class="font-inter text-sm sm:text-base text-center">
                    You pick the influencer, we manage everything else — from contracts to content and payments — for a
                    smooth, impactful campaign.
                </div>
            </div>
        </div>
    </div>
</div>